import { useEffect, useState } from "react";
import { getAssignmentHistory } from "../api/documents";
import { AssignmentHistoryItem } from "../types/DocumentOwnerHistory";

export function useAssignmentHistory(
  companyId: string,
  documentId: string,
  open: boolean
) {
  const [items, setItems] = useState<AssignmentHistoryItem[]>([]);
  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(false);
  const [loading, setLoading] = useState(false);

  const pageSize = 20;

  useEffect(() => {
    if (!open) return;

    setItems([]);
    setPage(0);
  }, [open, documentId]);

  useEffect(() => {
    if (!open) return;

    const load = async () => {
      try {
        setLoading(true);

        const data = await getAssignmentHistory(
          companyId,
          documentId,
          page,
          pageSize
        );

        setItems((prev) =>
          page === 0 ? data.items : [...prev, ...data.items]
        );

        setHasMore(data.hasMore);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [page, open, companyId, documentId]);

  const loadMore = () => {
    if (!hasMore || loading) return;
    setPage((prev) => prev + 1);
  };

  return {
    items,
    hasMore,
    loading,
    loadMore,
  };
}